import { Theme } from '@mui/material'

const classes = {
  dialogPaper: (theme: Theme, isHspPlus = false) => ({
    backgroundColor: isHspPlus ? theme.palette.ui.surfaceContainerHigh : theme.palette.ui.surfaceVariant,
    borderRadius: theme.spacing(1.5),
  }),
  dialogActions: (theme: Theme, hasMultipleActions: boolean, isHspPlus = false) => ({
    backgroundColor: isHspPlus ? theme.palette.ui.surfaceContainerLowest : theme.palette.ui.surfaceContainer,
    padding: theme.spacing(2),
    justifyContent: hasMultipleActions ? 'space-between' : 'center',
  }),
  closeButton: (theme: Theme) => ({
    marginLeft: theme.spacing(-1),
    color: theme.palette.text.secondary,
  }),
  titleContainer: {
    flex: 1,
  },
  contentContainer: (theme: Theme, isHspPlus = false) => ({
    paddingX: 3,
    paddingY: 5,
    rowGap: 2,
    justifyContent: 'center',
    backgroundColor: isHspPlus ? theme.palette.ui.surfaceContainerHigh : theme.palette.ui.surfaceVariant,
  }),
  headerContainer: (theme: Theme, showCloseIcon: boolean, isHspPlus = false) => ({
    justifyContent: showCloseIcon ? 'flex-start' : 'center',
    alignItems: 'center',
    gap: 2,
    paddingX: 2,
    paddingY: 1,
    minHeight: '64px',
    backgroundColor: isHspPlus ? theme.palette.ui.surfaceContainerHigh : theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
  }),
  titleText: (showCloseIcon: boolean) => ({
    textAlign: 'center',
    ...(showCloseIcon ? { marginRight: 6 } : {}),
  }),
}

export default classes
